module.exports = __webpack_public_path__ + "img/Arkadijs-Mazjanis.7f7fc486.svg";